import React from 'react';
import { useParams } from 'react-router-dom';
import { featureCards } from '../constants/mockData';
import { ASSETS } from '../constants/assets';
import { ChevronLeft, Share2, Heart, MapPin, Clock, Ticket, Phone, Star, Flame, Navigation, CalendarCheck } from 'lucide-react';
import { Button } from '../components/Button';
import { Badge } from '../components/Badge';
export function ScenicDetail() {
  const {
    id
  } = useParams();
  const scenic = featureCards.find(c => c.id === Number(id)) || featureCards[0];
  return <div className="min-h-screen bg-white pb-24" data-id="element-295">
      {/* Hero Header */}
      <div className="relative h-[450px] w-full" data-id="element-296">
        <img src={scenic.image} alt={scenic.title} className="w-full h-full object-cover" data-id="element-297" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/60" data-id="element-298" />

        {/* Top Actions */}
        <div className="absolute top-12 left-0 right-0 px-4 flex items-center justify-between z-10" data-id="element-299">
          <button onClick={() => window.history.back()} className="size-10 bg-black/20 backdrop-blur-md rounded-full flex items-center justify-center text-white" data-id="element-300">
            <ChevronLeft className="size-6" data-id="element-301" />
          </button>
          <div className="flex gap-3" data-id="element-302">
            <button className="size-10 bg-black/20 backdrop-blur-md rounded-full flex items-center justify-center text-white" data-id="element-303">
              <Share2 className="size-5" data-id="element-304" />
            </button>
            <button className="size-10 bg-black/20 backdrop-blur-md rounded-full flex items-center justify-center text-white" data-id="element-305">
              <Heart className="size-5" data-id="element-306" />
            </button>
          </div>
        </div>

        {/* Bottom Info Overlay */}
        <div className="absolute bottom-8 left-6 right-6 text-white" data-id="element-307">
          <div className="flex gap-2 mb-3" data-id="element-308">
            {scenic.tags.map(tag => <Badge key={tag} className="bg-[#66CADA] text-white border-none px-3 py-0.5" data-id="element-309">
                {tag}
              </Badge>)}
          </div>
          <h1 className="text-3xl font-bold" data-id="element-310">{scenic.title}</h1>
          <div className="flex items-center gap-4 mt-3 opacity-90" data-id="element-311">
            <div className="flex items-center gap-1" data-id="element-312">
              <Star className="size-4 fill-yellow-400 text-yellow-400" data-id="element-313" />
              <span className="text-sm font-bold" data-id="element-314">4.8</span>
            </div>
            <div className="w-px h-3 bg-white/30" data-id="element-315" />
            <div className="flex items-center gap-1" data-id="element-316">
              <Flame className="size-4 text-red-400 fill-current" data-id="element-317" />
              <span className="text-sm font-bold" data-id="element-318">热度 {scenic.heatScore}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Content Body */}
      <div className="px-6 -mt-6 relative z-10 bg-white rounded-t-[48rpx] pt-8 flex flex-col gap-8" data-id="element-319">
        {/* Quick Info Grid */}
        <div className="grid grid-cols-2 gap-4" data-id="element-320">
          <div className="bg-[#EEF8F8] p-4 rounded-3xl flex items-center gap-3" data-id="element-321">
            <div className="size-10 bg-white rounded-2xl flex items-center justify-center text-[#66CADA]" data-id="element-322">
              <Clock className="size-5" data-id="element-323" />
            </div>
            <div data-id="element-324">
              <p className="text-[20rpx] text-[#999999]" data-id="element-325">开放时间</p>
              <p className="text-sm font-bold text-[#333333]" data-id="element-326">08:30-18:00</p>
            </div>
          </div>
          <div className="bg-[#EEF8F8] p-4 rounded-3xl flex items-center gap-3" data-id="element-327">
            <div className="size-10 bg-white rounded-2xl flex items-center justify-center text-[#66CADA]" data-id="element-328">
              <Ticket className="size-5" data-id="element-329" />
            </div>
            <div data-id="element-330">
              <p className="text-[20rpx] text-[#999999]" data-id="element-331">门票信息</p>
              <p className="text-sm font-bold text-[#333333]" data-id="element-332">免费开放</p>
            </div>
          </div>
        </div>

        {/* Description */}
        <div className="flex flex-col gap-3" data-id="element-333">
          <h2 className="text-xl font-bold text-[#333333]" data-id="element-334">景区简介</h2>
          <p className="text-[#666666] leading-relaxed text-sm" data-id="element-335">
            {scenic.description} 宿州{scenic.title}
            作为当地核心文旅资源，承载着深厚的历史底蕴与自然美景。这里不仅是游客休闲度假的理想之地，更是了解宿州文化的重要窗口。
          </p>
        </div>

        {/* Location */}
        <div className="flex flex-col gap-4" data-id="element-336">
          <h2 className="text-xl font-bold text-[#333333]" data-id="element-337">地理位置</h2>
          <div className="bg-gray-50 p-4 rounded-3xl flex items-center justify-between border border-gray-100" data-id="element-338">
            <div className="flex items-center gap-3" data-id="element-339">
              <div className="size-10 bg-[#66CADA]/10 rounded-2xl flex items-center justify-center text-[#66CADA]" data-id="element-340">
                <MapPin className="size-5" data-id="element-341" />
              </div>
              <div data-id="element-342">
                <p className="text-sm font-bold text-[#333333]" data-id="element-343">
                  宿州市埇桥区新汴河大道
                </p>
                <p className="text-xs text-[#999999] mt-0.5" data-id="element-344">
                  距离您当前位置 {scenic.distance}
                </p>
              </div>
            </div>
            <Button variant="ghost" size="icon" className="text-[#66CADA]" data-id="element-345">
              <Navigation className="size-6" data-id="element-346" />
            </Button>
          </div>
        </div>
      </div>

      {/* Bottom Sticky Actions */}
      <div className="fixed bottom-0 left-0 right-0 h-24 bg-white border-t border-gray-100 px-6 flex items-center gap-4 z-50" data-id="element-347">
        <div className="flex flex-col items-center gap-1 text-[#999999] px-2" data-id="element-348">
          <Phone className="size-5" data-id="element-349" />
          <span className="text-[18rpx]" data-id="element-350">咨询</span>
        </div>
        <div className="flex flex-col items-center gap-1 text-[#999999] px-2" data-id="element-351">
          <Heart className="size-5" data-id="element-352" />
          <span className="text-[18rpx]" data-id="element-353">收藏</span>
        </div>
        <Button className="flex-1 bg-[#66CADA] hover:bg-[#2BAABD] text-white rounded-full py-6 font-bold text-lg shadow-lg shadow-[#66CADA]/20" data-id="element-354">
          <CalendarCheck className="size-5 mr-2" data-id="element-355" />
          立即预约
        </Button>
      </div>
    </div>;
}